import type {
  MeetingDurationLimit,
  MeetingDurationOption,
  MeetingFormatCode,
  MeetingOptions,
} from "@/types";

import { BaseApi } from "./base.api";

export interface MeetingFormatPayload {
  enabled?: boolean;
  /** `null` — sabab olib tashlanadi, front standart matnini ko'rsatadi. */
  disabledNote?: string | null;
}

/** Davomiylik qo'shilayotganda birga keladigan chegara. */
export interface MeetingLimitPayload {
  format: MeetingFormatCode;
  minCoffees: number;
}

export interface CreateMeetingDurationPayload {
  minutes: number;
  enabled?: boolean;
  /**
   * Ko'rsatilmagan offlayn format eng past qiymatni oladi, onlayn esa
   * mavjud tariflardan proporsional hisoblanadi.
   */
  limits?: MeetingLimitPayload[];
  disabledNote?: string | null;
}

export type UpdateMeetingDurationPayload = Omit<CreateMeetingDurationPayload, "minutes" | "limits">;

/** Chegaraning bitta katagi — format va davomiylik MANZILDA. */
export interface UpdateMeetingLimitPayload {
  minCoffees?: number;
}

/**
 * Uchrashuv formatlari va davomiyliklari (ADR 0012).
 *
 * Formatlar QO'SHILMAYDI — ikkitasi kodga bog'langan, admin faqat
 * ularni yoqadi yoki o'chiradi. Davomiylik esa qo'shiladi va faqat
 * ISHLATILMAGANI o'chiriladi; qolganini o'chirib qo'yish kerak.
 */
class AdminMeetingOptionsApi extends BaseApi {
  list() {
    return this.request<MeetingOptions>("/admin/meeting-options");
  }

  updateFormat(code: MeetingFormatCode, payload: MeetingFormatPayload) {
    return this.request<MeetingOptions["formats"][number]>(
      `/admin/meeting-options/formats/${code}`,
      { method: "PATCH", body: payload },
    );
  }

  createDuration(payload: CreateMeetingDurationPayload) {
    return this.request<MeetingDurationOption>("/admin/meeting-options/durations", {
      method: "POST",
      body: payload,
    });
  }

  updateDuration(minutes: number, payload: UpdateMeetingDurationPayload) {
    return this.request<MeetingDurationOption>(`/admin/meeting-options/durations/${minutes}`, {
      method: "PATCH",
      body: payload,
    });
  }

  /**
   * Chegara matritsasining bitta katagi (ADR 0016).
   *
   * Har bir katak ALOHIDA saqlanadi: butun matritsani bitta forma
   * bilan yuborish "qaysi katak saqlandi?" degan savolni tug'dirardi
   * va bitta noto'g'ri son hammasini rad etardi.
   */
  updateLimit(minutes: number, format: MeetingFormatCode, payload: UpdateMeetingLimitPayload) {
    return this.request<MeetingDurationLimit>(
      `/admin/meeting-options/durations/${minutes}/limits/${format}`,
      { method: "PATCH", body: payload },
    );
  }

  deleteDuration(minutes: number) {
    return this.request<void>(`/admin/meeting-options/durations/${minutes}`, { method: "DELETE" });
  }
}

export const adminMeetingOptionsApi = new AdminMeetingOptionsApi();
